// import axios from 'axios/index'
import {FuseUtils} from '@fuse'
// import {showMessage} from 'store/actions/fuse'
// import {eCommerceDB} from 'fake-db/e-commerce-db'
import api from 'api'

// const {products} = eCommerceDB

export const GET_PRODUCT = '[E-COMMERCE APP] GET PRODUCT'
export const SAVE_PRODUCT = '[E-COMMERCE APP] SAVE PRODUCT'
export const REMOVE_PRODUCT = '[E-COMMERCE APP] REMOVE PRODUCT'

export function getProduct({productId} = {}) {
  return dispatch =>
    api.getById(productId).then(doc => {
      if (doc.exists) {
        return dispatch({
          type: GET_PRODUCT,
          payload: {...doc.data(), id: doc.id},
        })
      }
    })
}

export function saveProduct(data) {
  const {id} = data
  return dispatch =>
    api.addById(id, data).then(() =>
      dispatch({
        type: SAVE_PRODUCT,
        payload: {},
      }),
    )
}

export function newProduct() {
  const data = {
    id: FuseUtils.generateGUID(),
    name: '',
    handle: '',
    description: '',
    categories: [],
    tags: [],
    images: [],
    priceTaxExcl: 0,
    priceTaxIncl: 0,
    taxRate: 0,
    comparedPrice: 0,
    quantity: 0,
    sku: '',
    width: '',
    height: '',
    depth: '',
    weight: '',
    extraShippingFee: 0,
    active: true,
  }

  return {
    type: GET_PRODUCT,
    payload: data,
  }
}

export function removeProduct(id) {
  return dispatch =>
    api.removeById(id).then(() =>
      dispatch({
        type: REMOVE_PRODUCT,
        payload: {},
      }),
    )
}



// WEBPACK FOOTER //
// ./src/main/content/store/actions/product.actions.js